// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jsZn","type":"styles_type__2N3uE","choices":"styles_choices__j30Hm"};